<template>
  <div>
    <div>
      <v-card v-if="done" class="mb-4">
        <v-card-title>
          Thank you for your vote!
        </v-card-title>
      </v-card>
    </div>
    <div v-if="!done">
      <v-card class="mb-4">
        <v-card-title>
          Choose the characters for each scene.
        </v-card-title>
      </v-card>
      <v-stepper v-model="e1">

        <v-stepper-items>
          <v-stepper-content v-for="n in steps" :key="`${n}-content`" :step="n">
            <v-card class="mb-12">
              {{ scenes[n - 1].title }}
              <b>Choose {{ scenes[n - 1].actors }} actor(s)</b>

              <v-list>
                <v-list-tile v-for="actor in actors" :key="actor.id" avatar>
                  <v-list-tile-action>
                    <v-checkbox
                      v-if="actor.SceneId === scenes[n - 1].id"
                      v-model="selected"
                      :value="actor"
                      :label="actor.name"
                      selected
                      @change="setId(0, actor.id)"
                    ></v-checkbox>
                    <v-checkbox
                      v-else-if="actor.SceneId === 0 || actor.SceneId === null"
                      v-model="selected"
                      :value="actor"
                      :label="actor.name"
                      @change="setId(n - 1, scenes[n - 1].id, actor.id, n)"
                    ></v-checkbox>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card>

            <v-btn v-if="n === 6" color="primary" @click="submit()">
              Submit
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import Api from '@/services/Api'

export default {
  data() {
    return {
      e1: 1,
      steps: 5,
      performance: {},
      scenes: [],
      actors: [],
      selected: [],
      done: false,
    }
  },

  created() {
    this.getPerformance()
    this.getActors()
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
  },

  methods: {
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },

    async getPerformance() {
      const response = await Api().get('get_performance')

      this.performance = response.data[0]
      console.log(this.performance)
      console.log('id', this.performance.id)
      const response1 = await Api().get('get_scenes/' + this.performance.id)

      this.scenes = response1.data
      this.steps = this.scenes.length
      console.log(this.scenes)
    },

    async submit() {
      // const response = await Api().put('save_vote', this.actors)
      // console.log(response.data)
      this.done = true
    },

    async getActors() {
      const response = await Api().get('get_actors')

      this.actors = response.data
      console.log('actors', this.actors)
    },

    setId(sId, sceneId, actorId, n) {
      this.scenes[sId].actors--
      console.log('test', sId, sceneId, actorId, this.scenes[sId].actors)

      if (this.scenes[sId].actors > 0 || this.steps === n) {
        const index = this.actors.findIndex(item => item.id === actorId)

        if (index !== -1) {
          this.actors[index].SceneId = sceneId
        }
      } else {
        const index = this.actors.findIndex(item => item.id === actorId)

        if (index !== -1) {
          this.actors[index].SceneId = sceneId
        }

        console.log('next step')
        this.nextStep(n)
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
